module.exports = "<div class=\"terms-of-service-page\">\n    <label translate>Terms of service changed</label>\n    &nbsp;&nbsp;&nbsp;&nbsp;\n    <a class=\"text-primary\" target=\"_blank\" ng-click=\"ctrl.goToTermsOfService()\" translate>Please click to read</a>\n    &nbsp;&nbsp;&nbsp;&nbsp;\n    <br>\n    <button class=\"btn btn-primary\" ng-click=\"ctrl.userAgreeGoToPanels()\">I AGREE</button>\n\n</div>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/guest/termsOfService/template.html
 ** module id = 868
 ** module chunks = 0
 **/